import axios from "axios";
import { FETCH_ASSET, HANDLE_ERRORS, LOADING_MODE } from "./types";
import BASE_URL from '../helpers/base-url';
import authorizeRequest from "../helpers/authorize-request";

export const getAsset = () => async dispatch => {
  try {
    dispatch({ type: LOADING_MODE, payload: true });
    const response = await axios.get(`${BASE_URL}/api/file/asset`, authorizeRequest());

    dispatch({
      type: HANDLE_ERRORS,
      payload: { message: "", open: false }
    });

    dispatch({
      type: FETCH_ASSET,
      payload: response
    });
    dispatch({ type: LOADING_MODE, payload: false });
    dispatch({
      type: HANDLE_ERRORS,
      payload: { message: "", open: false }
    });
  } catch (error) {
    console.error("Error fetching asset local file ", error);
    dispatch({
      type: HANDLE_ERRORS,
      payload: { message: error.message, open: true }
    });
    dispatch({ type: LOADING_MODE, payload: false });
  }
};



// WEBPACK FOOTER //
// ./src/actions/getAsset.js